export default {"src":"/_next/static/media/icon-messenger.54c31489.svg","height":59,"width":62,"blurWidth":0,"blurHeight":0};